export default "__VITE_ASSET__aWMto3F6__"